import {useState} from "react";
import {Button, Offcanvas} from "react-bootstrap";
import {useAuth} from "../../../../AuthUser";
import {useParams} from "react-router-dom";
import moment from "moment";
import API from "../../../../api";
import ProfileImage from "../../../../components/ProfileImage";
import { toast } from "react-toastify";
import RichText from "../../../../components/RichText";
import CommentEditor from "../../../../components/CommentEditor";
import {normalizeQuillHtml, richTextHasText} from "../../../../components/QuillInput";

function Comment(comment) {
	const [show, setShow] = useState(false);
	const [deleted, setDeleted] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = (e) => {
		e.preventDefault()
		setShow(true);
	}

	const success = (message) =>
		toast.success(message, {
			position: toast.POSITION.TOP_RIGHT,
		});

	const handleDelete = async (e,commentId) => {
		e.preventDefault()
		if(window.confirm("Are you sure you want to delete this comment?")) {
			await API.delete(`videoComments/${commentId}`);
			success("Successfully deleted comment");
			setDeleted(true);
		}
	}

	const [result, setResult] = useState();
	const [disabled, setDisabled] = useState(false);
	const [isSubmitting, setSubmitting] = useState(false);
	const [text, setText] = useState('');

	const auth = useAuth();
	let { slug } = useParams();
	comment = comment.comment;

	const noName = `user00${auth.user.id+ auth.user.id}`;

	const handleSubmit = (e) => {
		e.preventDefault();
		// An "empty" Quill document is "<p><br></p>", so a truthy check on the
		// value would happily post a blank reply.
		if (!richTextHasText(text)) {
			return;
		}
		// Quill turns every space into &nbsp;, which blocks wrapping wherever
		// this is rendered. Normalize on submit, never in onChange.
		const body = normalizeQuillHtml(text);
		setSubmitting(true);
		API.post(`videoComments/${slug}`, {
			comment: body,
			bodyFormat: 'html',
			creator: auth.user.id,
			parentId: comment.id,
		})
			.then(() => setResult(body))
			.finally(() => {
					setSubmitting(false);
					setDisabled(true)
					handleClose()
					setText('');
				}
			);
	}

	const reply = (comments) => <div className="comment-container">
		<div className='comments'>
			<div className="d-flex flex-row mt-3 gap-3">
				<img src={auth.user.thumbnail} width="40" height="40" className="rounded-circle mr-3" alt="user"/>
				<div className="w-100">
					<div className="d-flex justify-content-between align-items-center">
						<div className="d-flex flex-row align-items-center">
							<span className="me-2">{auth.user?.firstName || noName}</span>
							<small className="text-orange"><strong>{auth.user.admin ? 'Master Instructor' : ''}</strong></small>
						</div>
						<small>{moment().fromNow()}</small>
					</div>
					<div className="text-justify comment-text mb-0"><RichText text={comments} format="html"/></div>
				</div>
			</div>
		</div>
	</div>
			return (
				<div className={deleted ? 'visually-hidden' : ''} key={comment.id}>
						<div className={`comments ${comment.parentId ? 'ms-3' : ''}`}>
							<div className="d-flex flex-row p-3 gap-3">
								<ProfileImage size={40} textSizeRatio={2.75} text={comment.creator.email}/>
								<div className="w-100">
									<div className="d-flex justify-content-between align-items-center">
										<div className="d-flex flex-row align-items-center">
											<span className="me-2">{comment.creator?.firstName || noName} {auth.user.admin ? comment.creator?.lastName || '' : ''}</span>
											<small className="text-orange"><strong>{comment.creator.admin ? 'Master Instructor' : ''}</strong></small>
										</div>
										<small>{moment(comment.created_at).fromNow()}</small>
									</div>
									<div className="text-justify comment-text mb-0"><RichText text={comment.comment} format={comment.bodyFormat}/></div>
									<div className="d-flex flex-row gap-1">
										{auth.user.planType ?
											<a href="#" className="ms-3 small text-decoration-none"
												 onClick={handleShow}><strong>Reply</strong></a>
											: ''}
										{auth.user.admin || auth.user.id === comment.creator.id ?
											<a href="#" className="ms-3 small text-decoration-none"
												 onClick={(e) =>
													 handleDelete(e,comment.id)}><strong>Delete</strong></a>
											: ''}
									</div>
									{result ? reply(result) : ''}
								</div>
							</div>
						</div>
					<Offcanvas className="offcanvas-backdrop-blue" show={show} onHide={handleClose} placement="bottom" backdrop="static" scroll={true}>
						<Offcanvas.Header closeButton>
							<Offcanvas.Title/>
						</Offcanvas.Header>
						<Offcanvas.Body>
							<div className="text-justify comment-text"><RichText text={comment.comment} format={comment.bodyFormat}/></div>
							<form className="" onSubmit={handleSubmit}>
								<div className="d-flex flex-row align-items-center gap-3">
									<CommentEditor value={text} onChange={setText} placeholder="Enter your comment..." readOnly={disabled}/>
								</div>
								<div className="mt-2 float-end">
									<Button size="sm" variant="primary" type="submit" disabled={disabled}>
										{isSubmitting ? (
											<>
													<span
														className="spinner-border spinner-border-sm"
														role="status"
														aria-hidden={true}
													/>{" "}
											</>
										) : (
											"Comment"
										)}
									</Button>
								</div>
							</form>
						</Offcanvas.Body>
					</Offcanvas>
				</div>
			)
}

export default Comment;
